import { ReactNode } from 'react';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { Routes, Route, Link, Navigate, useNavigate } from "react-router-dom";
import Login from './pages/login';
import { AuthProvider, useAuth } from './auth/auth-context'
import {BsPerson} from 'react-icons/bs'
import { Dashboard } from './pages/dashboard/dashboard';
import UserSettings from './pages/user-settings/user-settings';
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import UserManagement from './pages/user-management/user-management';
import { AppProvider, useAppContext } from './AppContext';
import AlertReport from './pages/reports/alert-report/alert-report';
import SignupForm from './pages/signup';
const isDev = process.env.NODE_ENV === 'development'


function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  )
}

const UserDropdown = () => {
  return (
    <div className="d-flex align-items-center">
      <BsPerson style={{ fontSize: '1.5rem', marginRight: '0.5rem' }} />
    </div>
  )
}



function MyNavbar() {
  const navigate = useNavigate()
  const { logout,isLoggedIn, user } = useAuth()
  const {isPdf} = useAppContext()
  const handleLogout = () => {
    logout()
    navigate('/login')
  }
  if(isPdf) return <></>

  const origin = isDev ? 'http://localhost:3050' : 'https://api.affdash.nordpar.com'
  const img = origin + '/logo' + (user?.username ? '/' + user?.username : '')
  return (
    <Navbar expand="md" className='bg-light-subtle'>
      <Container fluid>
        <Navbar.Brand as={Link} to="/">
          <img
            src={img}
            height="30"
            id="p_home_brand"
            alt="Navbar Brand"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNavDropdown" />
        <Navbar.Collapse id="navbarNavDropdown">
          {isLoggedIn ? 
          <Nav className="w-100">

            <NavDropdown
              title={<UserDropdown />}
              id="basic-nav-dropdown"
              align="end"
              className="ms-md-auto me-md-2 hide-dropdown-arrow"
            >
              <NavDropdown.Item as={Link} to="/user-settings" id="u_settings">
                User settings
              </NavDropdown.Item>
              {user?.isAdmin ? <NavDropdown.Item as={Link} to="/user-management" id="u_management"> User management</NavDropdown.Item> : ''}
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
            </NavDropdown>
          </Nav>
          : '' }
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

const SecuredComponent = (opts: {element: ReactNode } )=> {
  const { isLoggedIn } = useAuth()
  

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  return (<>{opts.element}</>)
}

const AdminSecuredComponent = (opts: {element: ReactNode } )=> {
  const { isLoggedIn, user } = useAuth()
  

  if (!isLoggedIn || !user?.isAdmin) {
    return <Navigate to="/login" replace />;
  }
  return (<>{opts.element}</>)
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <AuthProvider>
          <MyNavbar />
            <Routes>
              <Route path="/" element={<SecuredComponent element={<Dashboard />} />}>
                <Route path="/d/:network" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/transaction-report" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/reference-report" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/publisher-report" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/campaign-report" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/click-report" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/feed-management" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/link-script" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/link-script/settings" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/link-builder" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/alerts" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/network-settings" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/scheduled-reports" element={<SecuredComponent element={<Dashboard />} />} />
                <Route path="/eb-pristjek" element={<SecuredComponent element={<Dashboard />} />} />
              </Route>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignupForm />} />
              <Route path="/alert-report" element={<AlertReport />} />
              <Route path="/user-settings" element={<SecuredComponent element={<UserSettings />} />} />
              <Route path="/user-management" element={<AdminSecuredComponent element={<UserManagement />} />} />
              <Route path="*" element={<NoMatch />} />
            </Routes>
        </AuthProvider>
      </AppProvider>
    </div>
  );
}

export default App;
